import React from 'react';
import type { Supplier } from '../../../types/supplyChain';
import { partnershipBadgeLabel } from '../../../lib/supplierPartnership';
import { isSupplierDataStale } from '../../../lib/scmDisclaimer';
import { cn } from '../../../lib/utils';

export interface SupplierPartnershipBadgeProps {
  supplier: Supplier | undefined | null;
  className?: string;
}

export const SupplierPartnershipBadge: React.FC<SupplierPartnershipBadgeProps> = ({
  supplier,
  className,
}) => {
  const label = partnershipBadgeLabel(supplier);
  if (!label) return null;
  return (
    <span
      className={cn(
        'inline-flex px-1.5 py-0.5 type-meta font-bold uppercase tracking-widest',
        'bg-warning/15 text-warning border border-warning/40',
        className,
      )}
      data-testid={`scm-partner-badge-${supplier?.id}`}
    >
      {label}
    </span>
  );
};

export const SupplierStaleBadge: React.FC<{ supplier: Supplier | undefined | null }> = ({ supplier }) => {
  if (!isSupplierDataStale(supplier?.dataFreshness)) return null;
  return (
    <span className="inline-flex px-1.5 py-0.5 type-meta text-warning border border-warning/40">
      Verify with supplier
    </span>
  );
};
